import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import { Modal } from './Modal';

// Potwierdzenie operacji nieodwracalnej.
//
// Zastępuje window.confirm(), który był używany przy usuwaniu kontenerów
// i stocków. Natywne okno nie pozwala pokazać, CZEGO dotyczy operacja
// (kasowanie stocku z komunikatem "Czy na pewno chcesz usunąć ten stock?"
// nie mówi którego), blokuje cały wątek przeglądarki i w niektórych
// przeglądarkach da się je trwale wyłączyć — a wtedy usuwanie działa
// bez żadnego potwierdzenia.

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Potwierdź operację',
  description,
  confirmLabel = 'Usuń',
  cancelLabel = 'Anuluj',
  variant = 'danger',
  // Nie każda operacja wymagająca potwierdzenia jest nieodwracalna —
  // przeniesienie do kosza da się cofnąć. Straszenie wtedy komunikatem
  // o braku odwrotu uczy ignorowania go tam, gdzie jest prawdziwy.
  hideIrreversibleNote = false,
  children,
}) {
  const [isWorking, setIsWorking] = useState(false);

  const handleConfirm = async () => {
    setIsWorking(true);
    const result = await onConfirm();
    setIsWorking(false);
    // Modal zostaje otwarty, jeśli operacja się nie powiodła — komunikat błędu
    // pojawia się w powiadomieniu, a użytkownik może spróbować ponownie.
    if (result?.ok !== false) onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button onClick={onClose}>{cancelLabel}</Button>
          <Button variant={variant} onClick={handleConfirm} loading={isWorking}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-danger-line bg-danger-soft text-danger">
          <AlertTriangle size={17} />
        </span>
        <div className="min-w-0 flex-1">
          {description && <p className="text-sm text-content">{description}</p>}
          {children}
          {!hideIrreversibleNote && (
            <p className="mt-2 text-xs text-muted">Tej operacji nie można cofnąć.</p>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
